module.exports = __webpack_public_path__ + "img/left_right_layout_6.595dc2d0.jpg";